const getFormattedMobile = (mobile: string) => {
  const cleaned = mobile.replace(/\D/g, "");

  // 12 digits starting with 91 = country code already included
  if (cleaned.length === 12 && cleaned.startsWith("91")) {
    return `+${cleaned}`;
  }

  // 10 digits = Indian mobile number
  if (cleaned.length === 10) {
    return `+91${cleaned}`;
  }

  return null;
};

const getMsg91Window = () => window as any;

export const sendOtpUsingWidget = (mobile: string) =>
  new Promise((resolve, reject) => {
    const win = getMsg91Window();
    if (!win || typeof win.sendOtp !== "function") {
      return reject(new Error("sendOtp not available"));
    }

    try {
      // console.log("mobile",mobile);
      // console.log("getFormattedMobile(mobile)",getFormattedMobile(mobile));
      win.sendOtp(
        getFormattedMobile(mobile),
        (response: any) => resolve(response),
        (error: any) => reject(error),
      );
    } catch (e) {
      reject(e);
    }
  });

export const verifyOtpUsingWidget = (otp: string) =>
  new Promise((resolve, reject) => {
    const win = getMsg91Window();
    if (!win || typeof win.verifyOtp !== "function") {
      return reject(new Error("verifyOtp not available"));
    }

    try {
      win.verifyOtp(
        otp,
        (response: any) => resolve(response),
        (error: any) => reject(error),
      );
    } catch (e) {
      reject(e);
    }
  });

export const resendOtpUsingWidget = (mobile?: string) =>
  new Promise((resolve, reject) => {
    const win = getMsg91Window();
    if (!win || typeof win.retryOtp !== "function") {
      return reject(new Error("retryOtp not available"));
    }

    try {
      win.retryOtp(
        '11',
        (response: any) => resolve(response),
        (error: any) => reject(error),
      );
    } catch (e) {
      reject(e);
    }
  });
